import api from '@/apis/ca/cAPaymentAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('approveVoucherCAPayment', api);

const state = {
  ...crud.state,
  _config: {
    table: 'ca_payment',
    field: {
      key: 'ref_id',
      code: 'ref_no', //lấy tên cho popup
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
